@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import club.srams.website.components.layouts.MarkdownLayout as _club_srams_website_components_layouts_MarkdownLayout
import club.srams.website.components.layouts.PageLayout as _club_srams_website_components_layouts_PageLayout
import club.srams.website.pages.AboutPage as _club_srams_website_pages_AboutPage
import club.srams.website.pages.AwesomePlacesPage as _club_srams_website_pages_AwesomePlacesPage
import club.srams.website.pages.ContactUsPage as _club_srams_website_pages_ContactUsPage
import club.srams.website.pages.EventCalendarPage as _club_srams_website_pages_EventCalendarPage
import club.srams.website.pages.FieldTripIntroductionPage as _club_srams_website_pages_FieldTripIntroductionPage
import club.srams.website.pages.FieldTripSchedulePage as _club_srams_website_pages_FieldTripSchedulePage
import club.srams.website.pages.FieldTripsPage as _club_srams_website_pages_FieldTripsPage
import club.srams.website.pages.FieldTripsPage_v2 as _club_srams_website_pages_FieldTripsPage_v2
import club.srams.website.pages.HomePage as _club_srams_website_pages_HomePage
import club.srams.website.pages.LearnIdentifyRocksPage as _club_srams_website_pages_LearnIdentifyRocksPage
import club.srams.website.pages.LearnTumbleRocksPage as _club_srams_website_pages_LearnTumbleRocksPage
import club.srams.website.pages.PebblePupsPage as _club_srams_website_pages_PebblePupsPage
import club.srams.website.pages.PebblePupsPage_v2 as _club_srams_website_pages_PebblePupsPage_v2
import club.srams.website.pages.RockhoundCodeEthicsPage as _club_srams_website_pages_RockhoundCodeEthicsPage
import club.srams.website.pages.TailgateSwapPage as _club_srams_website_pages_TailgateSwapPage
import club.srams.website.pages.TailgateSwapPage_v2 as _club_srams_website_pages_TailgateSwapPage_v2
import club.srams.website.pages.TailgateVendorPage as _club_srams_website_pages_TailgateVendorPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Shelton Rock and Mineral Society"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "club.srams.website.components.layouts.MarkdownLayout",
            parentLayoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _club_srams_website_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "club.srams.website.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _club_srams_website_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "club.srams.website.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_AboutPage()
        }
        ctx.router.register(
            "/awesome-places",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initAwesomePlacesPageV2(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_AwesomePlacesPage()
        }
        ctx.router.register(
            "/contact-us",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initContactUsPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_ContactUsPage()
        }
        ctx.router.register(
            "/event-calendar",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initEventCalendarPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_EventCalendarPage()
        }
        ctx.router.register(
            "/field-trip-introduction",
            layoutId = "club.srams.website.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initFieldTripIntroductionPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_FieldTripIntroductionPage()
        }
        ctx.router.register(
            "/field-trip-schedule",
            layoutId = "club.srams.website.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initFieldTripSchedulePage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_FieldTripSchedulePage()
        }
        ctx.router.register(
            "/field-trips",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initFieldTripsPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_FieldTripsPage()
        }
        ctx.router.register(
            "/field-trips-v2",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initFieldTripsPage_v2(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_FieldTripsPage_v2()
        }
        ctx.router.register(
            "/learn_identify_rocks",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initLearnIdentifyRocks(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_LearnIdentifyRocksPage()
        }
        ctx.router.register(
            "/learn_tumble_rocks",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initLearnTumbleRocks(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_LearnTumbleRocksPage()
        }
        ctx.router.register(
            "/pebble-pups-page",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initPebblePupsPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_PebblePupsPage()
        }
        ctx.router.register(
            "/pebble-pups-v2",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initPebblePupsPageV2(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_PebblePupsPage_v2()
        }
        ctx.router.register(
            "/rockhound-code-ethics",
            layoutId = "club.srams.website.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initRockhoundCodeEthicsPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_RockhoundCodeEthicsPage()
        }
        ctx.router.register(
            "/tailgate-swap-page",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initTailgateSwapPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_TailgateSwapPage()
        }
        ctx.router.register(
            "/tailgate-swap-v2",
            layoutId = "club.srams.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initTailgateSwapPage_v2(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_TailgateSwapPage_v2()
        }
        ctx.router.register(
            "/tailgate-vendor",
            layoutId = "club.srams.website.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                club.srams.website.pages.initTailgateVendorPage(ctx)
            },
        ) { pageCtx -> 
            _club_srams_website_pages_TailgateVendorPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("copyright", club.srams.website.CopyrightStyle)
        ctx.theme.registerStyle("headline-text", club.srams.website.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", club.srams.website.SubheadlineTextStyle)
        ctx.theme.registerStyle("section-text", club.srams.website.SectionTextStyle)
        ctx.theme.registerStyle("social-link", club.srams.website.SocialLinkStyle)
        ctx.theme.registerStyle("nav-header", club.srams.website.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("footer", club.srams.website.components.sections.FooterStyle)
        ctx.theme.registerStyle("page-content", club.srams.website.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("markdown", club.srams.website.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("pebble-pups-headline", club.srams.website.pages.PebblePupsHeadlineStyle)
        ctx.theme.registerStyle("page", club.srams.website.pages.PageStyle)
        ctx.theme.registerStyle("hero", club.srams.website.pages.HeroStyle)
        ctx.theme.registerStyle("section", club.srams.website.pages.SectionStyle)
        ctx.theme.registerStyle("section-inner", club.srams.website.pages.SectionInnerStyle)
        ctx.theme.registerStyle("card", club.srams.website.pages.CardStyle)
        ctx.theme.registerStyle("nav-button", club.srams.website.pages.NavButtonStyle)
        ctx.theme.registerStyle("section-heading", club.srams.website.pages.SectionHeadingStyle)
        ctx.theme.registerStyle("divider", club.srams.website.pages.DividerStyle)
        ctx.theme.registerStyle("chip", club.srams.website.pages.ChipStyle)
        ctx.theme.registerStyle("learn-identify-rocks-headline", club.srams.website.pages.LearnIdentifyRocksHeadlineStyle)
        ctx.theme.registerStyle("learn-identify-rocks-section", club.srams.website.pages.LearnIdentifyRocksSectionStyle)
        ctx.theme.registerStyle("learn-tumble-rocks-headline", club.srams.website.pages.LearnTumbleRocksHeadlineStyle)
        ctx.theme.registerStyle("learn-tumble-rocks-section", club.srams.website.pages.LearnTumbleRocksSectionStyle)
        ctx.theme.registerStyle("home-page-headline", club.srams.website.pages.HomePageHeadlineStyle)
        ctx.theme.registerStyle("hero-container", club.srams.website.pages.HeroContainerStyle)
        ctx.theme.registerStyle("home-grid", club.srams.website.pages.HomeGridStyle)
        ctx.theme.registerStyle("home-grid-cell", club.srams.website.pages.HomeGridCellStyle)
        ctx.theme.registerStyle("form", com.coding.meet.screens.contact_me.styles.formStyle)
        ctx.theme.registerVariant("-circle", club.srams.website.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", club.srams.website.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in", club.srams.website.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("fade-in-up-page", club.srams.website.components.layouts.fadeInUpPageAnimation)
        club.srams.website.initSiteStyles(ctx)
        club.srams.website.initColorMode(ctx)
        club.srams.website.initStyles(ctx)
        club.srams.website.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        club.srams.website.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
